// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  background: #0A0A1B !important;
  background-color: #0A0A1B !important;
  color-scheme: dark;
  -webkit-color-scheme: dark;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #0A0A1B !important;
  background-color: #0A0A1B !important;
  color: white;
  line-height: 1.6;
  min-height: 100vh;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #0A0A1B !important;
  background-color: #0A0A1B !important;
}

#root {
  background: #0A0A1B !important;
  background-color: #0A0A1B !important;
  min-height: 100vh;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.App-header h1 {
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
}

main {
  flex: 1 1;
  min-height: calc(100vh - 70px);
  background: #0A0A1B;
}

/* Global Typography */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 0.5rem;
}

p {
  margin-bottom: 1rem;
}

a {
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #5a6fd8;
}

/* Global Button Styles */
button {
  font-family: inherit;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

/* Global Input Styles */
input, textarea {
  font-family: inherit;
  border: none;
  outline: none;
}

/* Utility Classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.mb-1 { margin-bottom: 0.5rem; }
.mb-2 { margin-bottom: 1rem; }
.mb-3 { margin-bottom: 1.5rem; }
.mb-4 { margin-bottom: 2rem; }

.mt-1 { margin-top: 0.5rem; }
.mt-2 { margin-top: 1rem; }
.mt-3 { margin-top: 1.5rem; }
.mt-4 { margin-top: 2rem; }

.p-1 { padding: 0.5rem; }
.p-2 { padding: 1rem; }
.p-3 { padding: 1.5rem; }
.p-4 { padding: 2rem; }

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Loading Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out;
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 0 0.5rem;
  }
}

/* Focus Styles for Accessibility */
*:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

button:focus,
input:focus,
textarea:focus,
select:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .navbar,
  .navbar-actions,
  button {
    display: none !important;
  }
  
  body {
    background: white !important;
    color: black !important;
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2rem;
  color: #666;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
}

.error-message {
  color: #e74c3c;
  font-size: 1.1rem;
  text-align: center;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Safari-specific fixes */
@supports (-webkit-appearance: none) {
  html, body, #root, .App {
    background: rgb(10, 10, 27) !important;
    background-color: rgb(10, 10, 27) !important;
  }
}

/* WebKit Safari fix */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  html, body, #root, .App {
    background: #0B0B1C !important;
    background-color: #0B0B1C !important;
  }
}

/* Global gradient text class for main headings */
.gradient-text {
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;;AAE7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;;AAE1B,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;;AAEtB,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,sCAAsC;IACtC,4CAA4C;EAC9C;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;AACF;;AAEA,iDAAiD;AACjD;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  background: #0A0A1B !important;\n  background-color: #0A0A1B !important;\n  color-scheme: dark;\n  -webkit-color-scheme: dark;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #0A0A1B !important;\n  background-color: #0A0A1B !important;\n  color: white;\n  line-height: 1.6;\n  min-height: 100vh;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #0A0A1B !important;\n  background-color: #0A0A1B !important;\n}\n\n#root {\n  background: #0A0A1B !important;\n  background-color: #0A0A1B !important;\n  min-height: 100vh;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.App-header h1 {\n  font-size: 2rem;\n  font-weight: 600;\n  text-align: center;\n}\n\nmain {\n  flex: 1;\n  min-height: calc(100vh - 70px);\n  background: #0A0A1B;\n}\n\n/* Global Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600;\n  line-height: 1.3;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-bottom: 1rem;\n}\n\na {\n  color: #667eea;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\na:hover {\n  color: #5a6fd8;\n}\n\n/* Global Button Styles */\nbutton {\n  font-family: inherit;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\nbutton:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n/* Global Input Styles */\ninput, textarea {\n  font-family: inherit;\n  border: none;\n  outline: none;\n}\n\n/* Utility Classes */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mb-1 { margin-bottom: 0.5rem; }\n.mb-2 { margin-bottom: 1rem; }\n.mb-3 { margin-bottom: 1.5rem; }\n.mb-4 { margin-bottom: 2rem; }\n\n.mt-1 { margin-top: 0.5rem; }\n.mt-2 { margin-top: 1rem; }\n.mt-3 { margin-top: 1.5rem; }\n.mt-4 { margin-top: 2rem; }\n\n.p-1 { padding: 0.5rem; }\n.p-2 { padding: 1rem; }\n.p-3 { padding: 1.5rem; }\n.p-4 { padding: 2rem; }\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Loading Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-out;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 0 0.5rem;\n  }\n}\n\n/* Focus Styles for Accessibility */\n*:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\nbutton:focus,\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .navbar,\n  .navbar-actions,\n  button {\n    display: none !important;\n  }\n  \n  body {\n    background: white !important;\n    color: black !important;\n  }\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 2rem;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 1.1rem;\n  text-align: center;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Safari-specific fixes */\n@supports (-webkit-appearance: none) {\n  html, body, #root, .App {\n    background: rgb(10, 10, 27) !important;\n    background-color: rgb(10, 10, 27) !important;\n  }\n}\n\n/* WebKit Safari fix */\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  html, body, #root, .App {\n    background: #0B0B1C !important;\n    background-color: #0B0B1C !important;\n  }\n}\n\n/* Global gradient text class for main headings */\n.gradient-text {\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
